import BaseAbility from 'umg-ember-backend/abilities/base';

export default class A11yScannerAbility extends BaseAbility {}
